/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormSubmission
 */
export interface FormSubmission {
    /**
     * 
     * @type {number}
     * @memberof FormSubmission
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FormSubmission
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FormSubmission
     */
    sourceIp: string;
    /**
     * 
     * @type {any}
     * @memberof FormSubmission
     */
    content: any | null;
    /**
     * 
     * @type {Date}
     * @memberof FormSubmission
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FormSubmission
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the FormSubmission interface.
 */
export function instanceOfFormSubmission(value: object): value is FormSubmission {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('sourceIp' in value) || value['sourceIp'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FormSubmissionFromJSON(json: any): FormSubmission {
    return FormSubmissionFromJSONTyped(json, false);
}

export function FormSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormSubmission {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'sourceIp': json['source_ip'],
        'content': json['content'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function FormSubmissionToJSON(json: any): FormSubmission {
      return FormSubmissionToJSONTyped(json, false);
  }

  export function FormSubmissionToJSONTyped(value?: Omit<FormSubmission, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'source_ip': value['sourceIp'],
        'content': value['content'],
    };
}

